import { Tab, TabList, TabGroup } from '@headlessui/react';
import { classNames } from 'support/helpers/generic/generic';

type TabsListProps = {
  tabs: Array<{ label: string; badge?: string | number; route?: string }>;
  onChange: (index: number) => void;
  selected: number;
  className?: string;
};

export function TabsList({ tabs, onChange, selected, className }: TabsListProps) {
  return (
    <TabGroup onChange={onChange} defaultIndex={0} selectedIndex={selected} className="w-full">
      <TabList>
        <div className="hidden sm:block">
          <div className={classNames('border-b border-gray-200', className)}>
            <nav className="-mb-px flex" aria-label="Tabs">
              {tabs.map((tab) => (
                <Tab
                  key={tab.label}
                  className={({ selected }) =>
                    classNames(
                      'whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm focus:outline-none',
                      selected
                        ? 'border-gray-700 text-gray-900 '
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 ',
                    )
                  }
                >
                  {tab.label}

                  {tab.badge ? (
                    <span className="ml-2 rounded-full bg-gray-100 px-2 py-1 font-medium text-gray-800">
                      {tab.badge}
                    </span>
                  ) : null}
                </Tab>
              ))}
            </nav>
          </div>
        </div>
      </TabList>
    </TabGroup>
  );
}
